const announcementsNL = {
    "view": {
        "dropdown": {
            "unreadHeading": "{{count}} ongelezen aankondigingen",
            "empty": "Geen aankondigingen",
            "newBadge": "Nieuw",
            "dismissAll": "Alles negeren",
        },
        "modal": {
            "defaultTitle": "Aankondiging",
        },
        "table": {
            "title": "Aankondigingen",
            "column": {
                "title": "Titel",
                "datePosted": "Publicatiedatum",
                "dismissed": "Genegeerd",
                "status": "Status",
                "action": "Actie",
            },
            "status": {
                "read": "Gelezen",
                "unread": "Ongelezen",
            },
            "csv": {
                "statusRead": "Gelezen",
                "statusUnread": "Ongelezen",
                "dismissedYes": "Genegeerd",
                "dismissedNo": "Niet genegeerd",
            },
            "action": {
                "view": "Bekijken",
            },
            "button": {
                "exportCsv": "CSV exporteren",
            },
        },
    },
};

export default announcementsNL;
